import { render, staticRenderFns } from "./StrokeTopIcon.vue?vue&type=template&id=60972469&"
import script from "./StrokeTopIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeTopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports